import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { NbToastrService } from '@nebular/theme';

@Component({
  selector: 'tya-number-vn-input',
  templateUrl: './tya-number-vn-input.component.html',
  styleUrls: ['./tya-number-vn-input.component.scss']
})
export class TyaNumberVnInputComponent implements OnInit, OnChanges {
  @Input() value: string;
  @Input() statusInput: string = 'basic';
  @Output() changeValue = new EventEmitter<number>();
  @Input() disabled = false;

  constructor(private toast: NbToastrService) {}

  ngOnInit(): void {}

  ngOnChanges() {
    this.value = parseFloat(this.value).toLocaleString('vi-VN');
    if (this.value === 'NaN') {
      this.value = '';
    }
  }

  change() {
    let data = this.value.toString().replace(/\./g, '');
    data = data.replace(/\,/g, '.');

    if (isNaN(Number(data))) {
      this.toast.danger('Đã có lỗi trong quá trình nhập số. Vui lòng thử lại!');
      this.value = '0';
      this.changeValue.emit(0);
    } else {
      this.changeValue.emit(Number(data));
    }
  }
}
